export const dutchLock = {
  lang: 'nl',
  data: {
    LOCK: {
      TITLE: 'De sessie is geblokkeerd',
      MESSAGE: 'Vanwege inactiviteit is je sessie vergrendeld. Log opnieuw in.',
      Email: 'E-mail',
      PASSWORD: 'Wachtwoord',
      NOT_THIS_USER: 'Ben je niet',
      DEBLOCK: 'Ontgrendel',
      PASSWORD_REQUIRED: 'Wachtwoord verplicht',
    },
  },
}



// WEBPACK FOOTER //
// ./src/app/main/authentication/lock/i18n/nl.ts